/**
 * Global "free for everyone" campaign switch — web counterpart of the
 * mobile flag in `src/config/free-mode.ts` (mobile repo root). Keep the two
 * in sync: the campaign is either on everywhere or off everywhere.
 *
 * When enabled:
 * - `isPremiumTier()` treats every user as premium — all feature gates open
 *   (expense limit, CSV export, budgets, imports).
 * - Premium UI is hidden: paywalls/modals never trigger, the subscription
 *   row in ProfilePage is hidden.
 * - Analytics keep reporting the user's REAL tier plus a `FreeForAll`
 *   super property to segment campaign traffic.
 *
 * To end the campaign, set this to `false` and deploy.
 */
export const FREE_FOR_ALL_ENABLED = true;
